import React from 'react';
import styles from './styles.less';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { isEncodedAndNotDefault, isEncoded, EncodingPicker } from './EncodingPicker';
import {
    SizeLegendIndicator,
    YAxisLegendIndicator,
    IconLegendIndicator
} from './sparklineComponents';

export const Sparkline = ({
    name,
    yScale,
    children,
    componentType,
    className,
    id,
    width = `100%`,
    height = 50,
    loading = false,
    filtered = false,
    colors = false,
    isFilterEnabled = true,
    setEncoding,
    encodings,
    onClose,
    onClearHighlight,
    onYScaleChanged,
    styleNames = styles,
    ...restSparklineProps
}) => {
    return (
        <div
            {...restSparklineProps}
            className={
                className +
                ' ' +
                classNames({
                    [styleNames['has-filter']]: filtered,
                    [styleNames['has-coloring']]: colors,
                    [styleNames['filter-is-enabled']]: isFilterEnabled
                })
            }>
            <div className={styles['histogram-title']}>
                <SparklineIcons
                    loading={loading}
                    onClose={onClose}
                    id={id}
                    name={name}
                    componentType={componentType}
                    yScale={yScale}
                    onYScaleChanged={onYScaleChanged}
                    encodings={encodings}
                    setEncoding={setEncoding}
                    styleNames={styleNames}
                />
                <span>
                    {componentType || '\u00a0'}
                    {componentType ? ':' : ''}
                    &#8203;{name || '\u00a0'}
                </span>
            </div>
            <div
                style={{ width, height }}
                onMouseLeave={onClearHighlight}
                className={styles['histogram-picture']}>
                {children}
            </div>
        </div>
    );
};

function SparklineIcons({
    loading,
    onClose,
    id,
    name,
    componentType,
    yScale,
    onYScaleChanged,
    encodings,
    setEncoding,
    styleNames
}) {
    const { options } = encodings || {};
    return (
        <div className={styles['histogram-icons']}>
            {(setEncoding && componentType === 'point' && (
                <SizeLegendIndicator
                    sizeValue={isEncodedAndNotDefault(
                        encodings,
                        { componentType, attribute: name },
                        'size'
                    )}
                    onClick={() =>
                        setEncoding &&
                        setEncoding({
                            reset: isEncodedAndNotDefault(
                                encodings,
                                { componentType, attribute: name },
                                'size'
                            ),
                            attribute: name,
                            encodingType: 'size',
                            graphType: componentType,
                            name: componentType + 'Size'
                        })}
                />
            )) ||
                undefined}
            {(setEncoding && (
                <IconLegendIndicator
                    iconValue={isEncodedAndNotDefault(
                        encodings,
                        { componentType, attribute: name },
                        'icon'
                    )}
                    onClick={() =>
                        setEncoding &&
                        setEncoding({
                            reset: true,
                            attribute: name,
                            encodingType: 'icon',
                            graphType: componentType
                        })}
                />
            )) ||
                undefined}
            {(setEncoding && (
                <EncodingPicker
                    sizeValue={[]}
                    attribute={name}
                    options={options}
                    showModal={false}
                    yAxisValue={yScale}
                    encodings={encodings}
                    setEncoding={setEncoding}
                    componentType={componentType}
                    onYAxisChange={onYScaleChanged}
                    id={`histogram-encodings-picker-${name}`}
                />
            )) ||
                undefined}
            {(onYScaleChanged && (
                <YAxisLegendIndicator yAxisValue={yScale} onClick={() => onYScaleChanged(yScale === 'none' ? 'log' : 'none')} />
            )) ||
                undefined}
            {((onClose || loading) && (
                <Button
                    size="xsmall"
                    onClick={() => onClose && onClose({ id })}
                    className={classNames({
                        [styleNames['histogram-close']]: true,
                        [styleNames['histogram-loading']]: loading
                    })}>
                    {(loading && <span className="Select-loading" />) || (
                        <i className="fa fa-fw fa-times" />
                    )}
                </Button>
            )) ||
                undefined}
        </div>
    );
}
